import React, { useState, useEffect } from 'react';
import { Col, Row } from 'reactstrap';

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import AttachCardV2 from '../../../components/cards/attachCardV2';

import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalValidacionContrato = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [updFile, setUpdFile] = useState([]);

    const fileExist = (filename) => {
        const newArr = props.fileList.filter(file => file.fileName.split('.')[0] == filename)
        return { exists: newArr.length > 0, file: newArr.length > 0 ? newArr[0] : undefined }
    }

    const fileReadyToUpload = (filename) => {
        const newArr = updFile.filter(file => file.key === filename)
        return newArr.length > 0
    }

    const updateFile = (e) => {
        const tempArr = updFile
        tempArr.push(e)
        setUpdFile([...tempArr])
    }    

    const handleUpdate = async () => {
        const body = {
            cod_soli: props.id,
            cod_empr: userData.codigoEmpresa,
            data: {
                cmp_stat: 'REPORTE_NOMINA'
            }
        }
        const body2 = {
            estadoAPE: 'REPORTE_NOMINA'
        }
        await actualizarAPE(body);
        props.updateAPE(body2);
        props.toggle();
        props.toastSuccess('Estado Actualizado!');
    }

    const handleDevolver = async () => {
        props.setLoading(true);
        const body = {
            cod_soli: props.id,
            cod_empr: userData.codigoEmpresa,
            data: {
                cod_actu: props.data.flujo.cedulaCargaDocumentos ? props.data.flujo.cedulaCargaDocumentos : props.data.flujo.cedulaPrimerAprobador,
                cmp_stat: 'CARGA_CONTRATO'
            }
        }
        await actualizarAPE(body);
        props.toggle();
        props.setLoading(false);
        props.toastSuccess('Estado Actualizado!');
    }

    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => handleDevolver()}
                buttonTitle={'Aprobar'}
                customSalir={'Devolver'}
                onClick={() => handleUpdate()}
                buttonLoading={false}
                title={`Validacion de Documentos Contractuales`}
            >
                <Row>
                    <Col lg='4' md='4' xs='12'>
                        <Row>
                            <AttachCardV2
                                id={'DOCUMENTOS_CONTRACTUALES'}
                                file={fileExist('DOCUMENTOS_CONTRACTUALES').file}
                                apeId={props.id}
                                subText={`Documentos Contractuales Firmados`}
                                fileList={props.fileList}
                                setLoading={(e) => props.setLoading(e)}
                                setFileList={(e) => { props.setFileList(e) }}
                                attached={fileReadyToUpload('DOCUMENTOS_CONTRACTUALES') || fileExist('DOCUMENTOS_CONTRACTUALES').exists}
                            />
                        </Row>
                    </Col>
                    <Col lg='4' md='4' xs='12'>
                        <Row>
                            <AttachCardV2
                                id={'INDUCCIONES'}
                                file={fileExist('INDUCCIONES').file}
                                apeId={props.id}
                                subText={`Inducciones`}
                                fileList={props.fileList}
                                setLoading={(e) => props.setLoading(e)}
                                setFileList={(e) => { props.setFileList(e) }}
                                attached={fileReadyToUpload('INDUCCIONES') || fileExist('INDUCCIONES').exists}
                            />
                        </Row>
                    </Col>
                </Row>
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalValidacionContrato);